<template>
    <div class="container mt-4">
        <div class="row justify-content-center align-items-center g-3 mb-3">
            <div class="col-auto flex-grow-1 flex-basis">
                <div class="square_block">
                    <div class="label">{{ $t('admin.stats.totalPayingClients') }}:</div>
                    <div class="value">{{ totalPaidInstitutions  }}</div>
                </div>
            </div>
            <div class="col-auto flex-grow-1 flex-basis">
                <div class="square_block">
                    <div class="label">{{ $t('admin.stats.totalUsers') }}:</div>
                    <div class="value">{{ totalPaidUsers }}</div>
                </div>
            </div>
            <div class="col-auto flex-grow-1 flex-basis">
                <div class="square_block payment_block">
                    <div class="label">{{ $t('admin.stats.totalPaidAmount') }}:</div>
                    <div class="value">{{ formattedAmount }}</div>
                </div>
            </div>
        </div>
        <LineChart :series="seriesData"/>
    </div>
</template>

<script>
    import LineChart from '../components/LineChart.vue';

    export default {
        components: {
            LineChart
        },
        data() {
            return {
                totalPaidInstitutions: 0,
                totalPaidUsers: 0,
                totalPaidAmount: 0,
                chartData: [],
                seriesData: []
            };
        },
        created() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$store.getters.api.get("/stats/general").then(response => {
                    this.totalPaidInstitutions = response.data.total_paid_institutions;
                    this.totalPaidUsers = response.data.total_paid_users;
                    this.totalPaidAmount = response.data.total_paid_amount;

                    this.chartData = response.data.chart_data.map(item => ({
                        date: item.date,
                        paidUsers: item.total_paid_users
                    }));

                    this.updateSeriesData();
                })
            },
            updateSeriesData() {
                this.seriesData = [
                    {
                        name: this.$t('admin.stats.payingUsers'),
                        data: this.chartData.map(item => [new Date(item.date).getTime(), item.paidUsers])
                    }
                ];
            }
        },
        computed: {
            formattedAmount() {
                return (
                    new Intl.NumberFormat("cs-CZ", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    }).format(this.totalPaidAmount) + " Kč"
                );
            },
            seriesData() {
                return [
                    {
                        name: this.$t('admin.stats.payingUsers'),
                        data: this.chartData.map(item => [new Date(item.date).getTime(), item.paidUsers])
                    }
                ];
            }
        },
    }
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";

    .square_block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 16px 12px;
        width: 100%;
        background-color: $surface;
        border: 1px solid $border;
        height: 150px;
        border-radius: $radius-md;
        box-shadow: $shadow-sm;
    }
    .label {
        color: $text-muted;
        font-weight: 600;
        margin-bottom: 6px;
    }
    .value {
        font-size: clamp(20px, 2.4vw, 30px);
        font-weight: 700;
        color: $text;
        white-space: nowrap;
    }
    .payment_block {
        background-color: $surface-2;
        border-color: $border;
        position: relative;
    }
    .payment_block::before {
        content: "";
        position: absolute;
        left: 0;
        top: 12px;
        bottom: 12px;
        width: 3px;
        background: $accent;
        border-radius: 0 $radius-sm $radius-sm 0;
    }
</style>
